import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import PermissionDirective from "./directives/permission";
import VueApexCharts from 'vue-apexcharts'

window.__pendingStudentAuth = null;
window.addEventListener('message', (event) => {
  if (event.data && event.data.type === 'STUDENT_AUTH') {
    window.__pendingStudentAuth = {
      data: event.data,
      origin: event.origin,
      source: event.source,
      referrer: document.referrer
    };
  }
});

Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)

Vue.config.productionTip = false;

Vue.use(PermissionDirective);

function loadCustomization() {
  const savedCustomization = localStorage.getItem("customization");
  if (savedCustomization) {
    try {
      const customization = JSON.parse(savedCustomization);
      document.documentElement.style.setProperty(
        "--header-color",
        customization.headerColor,
      );
      document.documentElement.style.setProperty(
        "--background-color",
        customization.backgroundColor,
      );
    } catch (e) {
      console.error("Erro ao carregar personalização:", e);
    }
  }
}

loadCustomization();

store.commit("RESTORE_USER");

new Vue({
  store,
  router,
  render: (h) => h(App),
}).$mount("#app");
